import { render, staticRenderFns } from "./NewArrival.vue?vue&type=template&id=09acc7a6&scoped=true&"
import script from "./NewArrival.vue?vue&type=script&lang=js&"
export * from "./NewArrival.vue?vue&type=script&lang=js&"
import style0 from "./NewArrival.vue?vue&type=style&index=0&id=09acc7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acc7a6",
  null
  
)

export default component.exports